import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useIntercom } from '../../../../../contexts/intercomContext'
import { AlgoliaSearch } from '../AlgoliaSearch'
import { ArticlesSearch } from '../ArticlesSearch'
import { IntercomWidget } from './elements/IntercomWidget'
import { PopularArticlesWidget } from './elements/PopularArticlesWidget'
import { RecentMessagesBanner } from './elements/RecentMessagesBanner'
import * as Styled from './styles'

export const HelpModalContent = (): ReactElement => {
  const { organization } = useUserOrganization()
  const { unreadConversationsCount } = useIntercom()

  const SearchComponent = organization?.countryId === 'FR' ? ArticlesSearch : AlgoliaSearch

  return (
    <Styled.HelpModalContentWrapper>
      <Flex flexDirection="column" gap={Spacing.S16}>
        {unreadConversationsCount > 0 && <RecentMessagesBanner />}
        <SearchComponent />
      </Flex>
      <PopularArticlesWidget />
      <IntercomWidget />
    </Styled.HelpModalContentWrapper>
  )
}
